import React from "react";
import { Link } from "react-router-dom";
import ButtonHoverAnimation from "./button/ButtonHoverAnimation";

const Acquire = () => {
  return (
    <>
      <ButtonHoverAnimation />
      <main data-barba="container" data-barba-namespace="secondary">
        <div className="min-svh-100 d-flex align-items-center justify-content-center px-3 px-sm-4 px-md-5 opacity-load">
          <div className="container">
            <div className="spacer"></div>
            <div className="my-4">
              <h1 className="text-center">Select method</h1>
              <div className="d-flex flex-column w-100 flex-md-row flex-wrap align-items-center justify-content-center mt-4 gap-3 mt-lg-5">
                <div className="w-100" style={{ maxWidth: "300px" }}>
                  <Link className="btn-2 btnHover2 w-100" to="/staking">
                    <span className="position-relative">
                      <em className="d-block mb-3">
                        <img src="img/icon-staking.svg" alt="" />
                      </em>
                      Stake Pepecoin
                    </span>
                  </Link>
                </div>
                <div className="w-100" style={{ maxWidth: "300px" }}>
                  <Link className="btn-2 btnHover2 w-100" to="/burning">
                    <span className="position-relative">
                      <em className="d-block mb-3">
                        <img src="img/icon-burning.svg" alt="" />
                      </em>
                      Brain Credits
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            <div className="w-100 text-center">
              <div
                className="d-inline-block position-relative"
                style={{ top: "7vw" }}
              >
                <Link
                  className="underline-on-hover-2 d-flex align-items-center"
                  to="/"
                >
                  <em>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12.4526" cy="12.3848" r="12" fill="#75FBFD" />
                      <path
                        d="M13.7493 15.6265L11.1559 12.3848L13.7493 9.14306"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </em>
                  <span className="ps-2">Go Back</span>
                </Link>
              </div>
            </div>
            <div className="spacer"></div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Acquire;
